import { useEffect, useLayoutEffect, useState } from "react";

const currentTime = () => {
  const now = new Date();
  return new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};
const initialForm = (reason) => ({
  memo: "", actionAt: currentTime(), contactTarget: "", contactChannel: "전화",
  actionReason: reason, checkedContent: "", actionPlan: "", nextPlan: "",
  mode: "NOTE", nextCheckDate: "", recordScope: "LINE",
});

export function useActionDraft(open, key, reason) {
  const [state, setState] = useState(() => ({ key: "", form: initialForm(reason), baseline: "" }));
  const [restored, setRestored] = useState(false);
  const [storageError, setStorageError] = useState(false);
  useLayoutEffect(() => {
    if (!open) return;
    const form = initialForm(reason);
    let saved = null;
    try {
      const entry = JSON.parse(sessionStorage.getItem(key) || "null");
      if (entry?.version === 1 && Date.now() - entry.savedAt < 8 * 60 * 60 * 1000 &&
          Object.keys(form).every((field) => typeof entry.form?.[field] === "string") &&
          ["NOTE", "DONE", "FOLLOW_UP"].includes(entry.form.mode) &&
          ["ORDER", "LINE"].includes(entry.form.recordScope)) saved = entry.form;
      setStorageError(false);
    } catch { setStorageError(true); }
    setState({ key, form: saved || form, baseline: JSON.stringify(form) });
    setRestored(Boolean(saved));
  }, [open, key, reason]);

  const dirty = state.key === key && JSON.stringify(state.form) !== state.baseline;
  useLayoutEffect(() => {
    if (!open || !dirty) return;
    try {
      sessionStorage.setItem(key, JSON.stringify({ version: 1, savedAt: Date.now(), form: state.form }));
      setStorageError(false);
    } catch { setStorageError(true); }
  }, [open, dirty, key, state.form]);
  useEffect(() => {
    if (!open || !dirty) return;
    const warn = (event) => { event.preventDefault(); event.returnValue = ""; };
    window.addEventListener("beforeunload", warn);
    return () => window.removeEventListener("beforeunload", warn);
  }, [open, dirty]);

  const reset = () => {
    const form = initialForm(reason);
    try { sessionStorage.removeItem(key); } catch { setStorageError(true); }
    setState({ key, form, baseline: JSON.stringify(form) });
    setRestored(false);
  };
  return {
    ...state.form, dirty, restored, storageError, reset,
    setField: (name, value) => setState((previous) => ({ ...previous, form: { ...previous.form, [name]: value } })),
  };
}
